var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caption whitespace-pre-wrap",class:_vm.classes},[_vm._t("default",[_vm._v(_vm._s(_vm.texts))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }